import React, { useState,useEffect } from "react";
import axios from "axios";
import "../styles/ContactUs.css";
import Footer from '../component/footer';

const cdnURL = process.env.REACT_APP_CDN_URL;

const ContactUs = () =>  {

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [ContactInfo, setContactInfo] = useState(
        {
            'name': "",
            'email': "",
            'mobile': "",
            'message': "",
        }
    );

    const [result, setResult] = useState();

    const handleChange = (e) => {
        setContactInfo({ ...ContactInfo, [e.target.name]: e.target.value });
        
    };

    const apiUrl = process.env.REACT_APP_API_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!ContactInfo.name || !ContactInfo.email || !ContactInfo.mobile || !ContactInfo.message) {
            setResult("blankError");
            return;  
        }
        
        if (isSubmitting) return;
        setIsSubmitting(true);
        
        try {
            const res = await axios.post(`${apiUrl}/api/send-email`,
            ContactInfo,
            { headers: { "Content-Type": "application/json" },});

            if (res.data.success) {
                setResult("SendSuccess");
                setContactInfo({ name: "", email: "", mobile: "", message: "" });
            } 
            else {
                setResult("SendFailed");
            }
        }catch(error) {
            setResult("SendFailed");
        } finally {
            setIsSubmitting(false);
        }
        
    };


    const showResult = () => {
        if (result == "SendSuccess") {
            return (
                <div className="showResult" style={{color:"green"}}>
                    <a> Submission completed!</a>
                </div> 
            )
        }else if (result == "blankError") {
            return (
                <div className="showResult" style={{color:"red"}}>
                    <a> Fill in blank field before submission </a>
                </div> 
            )
        }else if (result == "SendFailed") {
            return (
                <div className="showResult" style={{color:"red"}}>
                    <a> An Error Occur </a>
                </div> 
            )
        }else {
            return (
                <div className="showResult">
                    <a> </a>
                </div> 
            )
        }
        
    }

    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };

    useEffect(() => {
        
        window.removeEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    })

    return (
        <div className="contactus_page">

            <div className="contactus_banner">
                <div className="contact_title">
                    <h1>Contact Us</h1>
                    <p>We'd love to hear from you. <br/><br/>Whether it is a question, feedback, or business enquiry, our team is ready to assist you. <br/>Let’s stay connected, because every conversation brings us closer to greater possibilities.</p>
                </div>

                <img src={`${cdnURL}/images/banner_contact_us.png`}/>
            </div>

            <div className="contactus_content">

                <div className="contactus_form">
                    <form onSubmit={handleSubmit}>
                        <div className="onerow">
                            <div className="contactfield">
                                <a>Full Name</a>
                                <input name="name" placeholder="Full Name" value={ContactInfo.name} onChange={handleChange}/>
                            </div>
                        </div>
                        <div className="onerow mobilecontact">
                            <div className="contactfield">
                                <a>Email</a>
                                <input name="email" placeholder="Email" value={ContactInfo.email} onChange={handleChange}/>
                            </div>
                            <div className="contactfield">
                                <a>Mobile Number</a>
                                <input name="mobile" placeholder="Mobile Number" value={ContactInfo.mobile} onChange={handleChange}/>
                            </div>
                        </div>
                        <div className="onerow">
                            <div className="contactfield">
                                <a>Message</a>
                                <textarea name="message" placeholder="Write your message" value={ContactInfo.message} rows="5" onChange={handleChange}/>
                            </div>
                        </div>

                        <div className="submit_btn">
                            <button className="btn btn-submit" type="submit" style={{ "--arrow-icon": `url(${cdnURL}/icon/icon_red_arrow.svg)` }}> <span>Submit</span></button>
                            {showResult()}
                        </div>
                    </form>
                        
                </div>

                <div className="contactus_address">
                    <div className="xox_address">
                        <p>Corporate Office</p>
                        <h1>Lot 17.1, Level 17, Menara Lien Hoe, <br/>No. 8, Persiaran Tropicana, <br/>Tropicana Golf & Country Resort, <br/>47410 Petaling Jaya, Selangor Darul Ehsan.</h1>
                    </div>

                    <div className="xox_map">
                        {
                        screenWidth > 600 ? 
                            <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3983.864179655932!2d101.59234182310054!3d3.130578803270424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sLot%2017.1%2C%20Level%2017%2C%20Menara%20Lien%20Hoe%2C%20No.%208%2C%20Persiaran%20Tropicana%2C%20Tropicana%20Golf%20%26%20Country%20Resort%2C%2047410%20Petaling%20Jaya%2C%20Selangor%C2%A0Darul%C2%A0Ehsan.!5e0!3m2!1sen!2smy!4v1758696100596!5m2!1sen!2smy" 
                             style={{ borderRadius: "20px", width:"100%", height:"15.833vw" }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>    
                        :
                            <iframe src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3983.864179655932!2d101.59234182310054!3d3.130578803270424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sLot%2017.1%2C%20Level%2017%2C%20Menara%20Lien%20Hoe%2C%20No.%208%2C%20Persiaran%20Tropicana%2C%20Tropicana%20Golf%20%26%20Country%20Resort%2C%2047410%20Petaling%20Jaya%2C%20Selangor%C2%A0Darul%C2%A0Ehsan.!5e0!3m2!1sen!2smy!4v1758696100596!5m2!1sen!2smy" 
                            style={{ borderRadius: "20px", width:"100%" }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        }
                    </div>
                </div>

            </div>

            <div style={{padding:"0px 5.208vw"}}>
                <Footer />
            </div>
        </div>
    );
};

export default ContactUs;